import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function useIsSmallAndUp() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('sm'));
}

export default useIsSmallAndUp;
